import { getUrl } from '@buffer-mono/shared-utils/bibe'

import { navigateTo } from '~publish/helpers/navigation'

import { trackLogoutOnRefreshFailure } from './authObservability'
import { CALLBACKS_PRODUCTION_URL, OIDC_LOGOUT_PATH } from './constants'

/**
 * Redirects to the OIDC logout endpoint when a silent token refresh fails. The
 * endpoint performs RP-initiated logout — clearing the OIDC cookies, ending the
 * provider session, and landing the user on the login page; see the
 * callbacks-service OIDC logout handler for the authoritative behavior.
 * `getUrl` env-stamps the callbacks host for dev/local/bibe.
 */
export function redirectToOidcLogout(): void {
  if (
    typeof window !== 'undefined' &&
    window.location.pathname === '/embedded-compose'
  ) {
    window.parent.postMessage({ type: 'buffer|close' }, '*')
    return
  }

  trackLogoutOnRefreshFailure()

  navigateTo(getUrl(`${CALLBACKS_PRODUCTION_URL}${OIDC_LOGOUT_PATH}`))
}
